import tile from "./tile"

export const Tile = tile